import { z } from 'zod';

export const locationFormSchema = z.object({
  locationName: z
    .string()
    .min(1, 'Location name is required')
    .max(120, 'Too long')
    .regex(/^[A-Za-z0-9_\- ]+$/, 'Letters, digits, spaces, _ and - only'),
});

export type LocationFormInput = z.infer<typeof locationFormSchema>;
